import { useParams } from 'react-router';
import { getAllMembersByOrg } from '@/services/members/get-all-members-by-org';
import { getOrgInfo } from '@/services/org/get-org-info';
import { MembersTableContainer } from '@/components/members/members-table-container';
import { useState, useCallback } from 'react';
import { Org } from '@/types';

type Params = {
  targetOrgId: string;
};

export const MembersByOrgPage = () => {
  const { targetOrgId: orgId = '' } = useParams<Params>();
  const [orgName, setOrgName] = useState<string>('');

  const fetchMembers = useCallback(async () => {
    try {
      const membersResult = await getAllMembersByOrg(orgId);
      const orgResult = await getOrgInfo(orgId);

      if (orgResult?.detail) {
        setOrgName('');
      } else {
        setOrgName((orgResult?.data as unknown as Org)?.name || '');
      }

      return membersResult;
    } catch (error) {
      console.error('Get members by org error:', error);
      return { detail: 'An unexpected error occurred' };
    }
  }, [orgId]);

  return (
    <MembersTableContainer
      organizationId={orgId}
      title={`${orgName} Members`}
      fetchMembers={fetchMembers}
    />
  );
};
